import { Tooltip } from "antd";
import { Dialog } from "primereact/dialog";
import { useState } from "react";
import _ from "../../../i18n";
import {
  generateFullName,
  getUserNameForAvatar,
  renderDurationDisplay,
} from "../../../utils";
import { ArrowRightOutlined } from "@ant-design/icons";

const DraggableDialog = ({ label, metaData }) => {
  const [visible, setVisible] = useState(false);

  const [firstName, lastName] = label.split(" ");
  return (
    <>
      <Tooltip
        placement="top"
        title={label}
        className={`${visible ? "avatar-rotate" : ""}`}
        onClick={() => setVisible(true)}
      >
        {renderAvatar("", firstName, lastName)}
      </Tooltip>
      <Dialog
        header={_("timesheet")}
        visible={visible}
        onHide={() => setVisible(false)}
        draggable
        resizable
        modal={false}
        dismissableMask={false}
        style={{ height: "65vh", width: 370, position: "realtive" }}
        className="custom-p-dialog"
      >
        {metaData && (
          <div className="progress">
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "flex-start",
                alignItems: "flex-start",
                gap: 5,
              }}
            >
              <h4>{metaData?.name}</h4>
              <p>{_(metaData?.grade)}</p>
            </div>

            <div className="progress-row">
              {_("absenceDay")}
              <span>
                {`${renderDurationDisplay(metaData?.offshore?.absence)}`}
              </span>
            </div>
            <div className="progress-row">
              {_("holidayDay")}
              <span>
                {`${renderDurationDisplay(metaData?.offshore?.holiday)}`}
              </span>
            </div>
            <div className="divider" />

            {/* Offshore */}
            <div className="progress-row">
              {_("formation")}
              <span>
                {`${renderDurationDisplay(metaData?.offshore?.formation)}`}
              </span>
            </div>
            <div className="progress-row">
              {_("offshore")}
              <span>
                {`${renderDurationDisplay(metaData?.offshore?.offshore)}`}
              </span>
            </div>
            <div className="progress-row">
              {_("computerBug")}
              <span className="computer_bg_span">
                {renderDurationDisplay(metaData?.offshore?.computerBug)}
                <div className="arrow-right">
                  <span>50%</span>
                  <ArrowRightOutlined size={14} />
                </div>
                {renderDurationDisplay(metaData?.offshore?.computerBug / 2)}
              </span>
            </div>
            {metaData?.offshore?.tempAbsence > 0 ? (
              <div className="progress-row">
                {_("tempAbsence")}
                <span>
                  {renderDurationDisplay(metaData?.offshore?.tempAbsence)}
                </span>
              </div>
            ) : (
              ""
            )}
            <div className="divider" />

            {/* Production */}
            <div className="progress-row">
              {_("expected")}
              <span>{renderDurationDisplay(metaData?.theoric)}</span>
            </div>
            <div className="progress-row">
              {_("real")}
              <span>{renderDurationDisplay(metaData?.real)}</span>
            </div>
          </div>
        )}
      </Dialog>
    </>
  );
};

export default DraggableDialog;

const renderAvatar = (avatarUrl, firstName, lastName) => {
  if (!avatarUrl && !firstName && !lastName) {
    return (
      <div className="avatar_not_exist" style={{ cursor: "pointer" }}>
        <p style={{ margin: "auto" }}>-</p>
      </div>
    );
  }
  let avatarDiv;
  if (!avatarUrl) {
    avatarDiv = (
      <div className="avatar_not_exist" style={{ cursor: "pointer" }}>
        <span>{getUserNameForAvatar(firstName, lastName)}</span>
      </div>
    );
  } else {
    avatarDiv = (
      <div className="avatar_exist" style={{ cursor: "pointer" }}>
        <img src={avatarUrl} alt={generateFullName(firstName, lastName)} />
      </div>
    );
  }

  return avatarDiv;
};
